import React, { useState } from "react";
import "../css/contactus.css";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import { Helmet } from "react-helmet";
import { AiFillInstagram, AiFillTikTok } from "react-icons/ai";

export default function ContactPage() {
  const [feedbackMessage, setFeedbackMessage] = useState("");
  const [feedbackClass, setFeedbackClass] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = {
      name: e.target.name.value,
      email: e.target.email.value,
      phone: e.target.phone.value,
      message: e.target.message.value,
    };

    try {
      const response = await fetch(
        "https://www.alphacontraining.co.uk/sendcontactemail",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        },
      );

      const result = await response.json();
      if (response.ok) {
        setFeedbackMessage("Your message has been sent successfully!");
        setFeedbackClass("success");
      } else {
        setFeedbackMessage(`Failed to send message: ${result.error}`);
        setFeedbackClass("error");
        setIsSubmitting(false);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setFeedbackMessage("There was an error. Please try again.");
      setFeedbackClass("error");
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Contact Us | Alpha Construction Training</title>
        <meta
          name="description"
          content="Contact Alpha Construction Training for inquiries about our services, training programs, and more. We're here to help — get in touch today!"
        />
        <link
          rel="canonical"
          href="https://www.alphacontraining.co.uk/contactus"
        />
      </Helmet>
      <Footer />

      <Navbar />
      <div className="contact-container">
        <div className="contact-main">
          {/* Left Info Column */}
          <div className="contact-left">
            <h2>Get In Touch</h2>
            <p>
              Have a question about training, certifications, or bookings? Speak
              directly with Alpha Construction Training.
            </p>

            <div className="contact-specs">
              <div>
                <span>Email</span>
                <a href="mailto:info@alphacontraining.co.uk">
                  info@alphacontraining.co.uk
                </a>
              </div>

              <div>
                <span>Phone</span>
                <a href="tel:+447475510591">+44 7475 510 591</a>
              </div>

              <div>
                <span>Location</span>
                <a
                  href="https://www.google.com/maps/search/?api=1&query=Alpha+Construction+Training+West+Bromwich"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  West Bromwich, UK
                </a>
              </div>
            </div>

            <div className="contact-social">
              <a
                href="https://www.tiktok.com/@alpha.con.training"
                target="_blank"
                rel="noopener noreferrer"
              >
                <AiFillTikTok />
              </a>
              <a
                href="https://www.instagram.com/alpha.con.training"
                target="_blank"
                rel="noopener noreferrer"
              >
                <AiFillInstagram />
              </a>
            </div>
          </div>

          {/* Right Form Column */}
          <div className="contact-right">
            <form className="contact-form" onSubmit={handleSubmit}>
              <h2>Send a Message</h2>
              {feedbackMessage && (
                <p className={`feedback-message ${feedbackClass}`}>
                  {feedbackMessage}
                </p>
              )}
              <input name="name" placeholder="Full Name" required />
              <input
                name="email"
                type="email"
                placeholder="Email Address"
                required
              />
              <input
                name="phone"
                type="tel"
                pattern="07[0-9]{9}"
                title="Please enter an 11-digit UK number starting with 07 (e.g., 07123456789)"
                placeholder="Phone Number (e.g. 07123456789)"
                maxLength="11"
                required
                onInput={(e) => {
                  // Instantly removes letters, spaces, or plus signs as they type
                  e.target.value = e.target.value.replace(/[^0-9]/g, "");
                }}
              />
              <textarea
                name="message"
                rows="5"
                placeholder="Your Message"
                required
              />
              <button type="submit" disabled={isSubmitting}>
                {isSubmitting ? "Message Sent" : "Submit"}
              </button>
            </form>
          </div>
        </div>
        {/* Map Section */}
        <div className="contact-map-section">
          <iframe
            title="Alpha Construction Training Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2428.045407403709!2d-1.9872994606297179!3d52.51451731608233!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487097d5d958e9f7%3A0x9b49aac3bdbbd3a4!2sAlpha%20Construction%20Training!5e0!3m2!1sen!2suk!4v1768953977931!5m2!1sen!2suk"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </>
  );
}
